import { ID } from '../../utils/codecUtils';
import { surveySchema } from '../models/survey.schema';

export const get = (surveyId: ID) => {
  return {
    endpoint: `/surveys/${surveyId}`,
    method: 'GET',
    responseSchema: surveySchema,
  } as const;
};
